export default __webpack_public_path__ + "static/media/Component25e311.2486d909.svg";